var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBehaviorChip4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 21.3333,
    height: 21.3333,
    viewBox: "0 0 21.3333 21.3333",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "barking"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.87391 13.35L14.5979 16.2259C15.2698 16.3838 15.6927 17.0697 15.5154 17.7328C15.3535 18.3881 14.6502 18.7998 13.9703 18.6269C13.9313 18.6274 13.8765 18.598 13.8296 18.5835L2.54578 14.3187C2.27962 14.2237 2.15836 13.9212 2.25585 13.6616C2.36142 13.4175 2.62395 13.2852 2.87391 13.35Z",
    fill: "#14CD71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3036 8.88906C19.1521 8.88906 19.9655 9.54798 19.9989 10.5844C20.0321 11.6206 19.152 12.4446 18.3036 12.4446L1.96939 11.4203C1.71362 11.4021 1.32224 11.0388 1.33311 10.6208C1.34423 10.2027 1.73579 9.89339 1.96939 9.87517L18.3036 8.88906Z",
    fill: "#14CD71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1473 2.84392C10.8055 2.46135 11.6489 2.72268 12.005 3.39514C12.3853 4.05746 12.1257 4.90667 11.4572 5.26493C11.3771 5.31365 11.2864 5.33784 11.2133 5.36909L2.94856 8.00538C2.66322 8.1129 2.34712 7.94445 2.24717 7.63993C2.16802 7.38434 2.2804 7.10459 2.51366 6.97586L10.1473 2.84392Z",
    fill: "#14CD71"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehaviorChip4);
export default __webpack_public_path__ + "static/media/behavior-chip-4.076751686ed9ba6c5af7c2c3aee8401d.svg";
export { ForwardRef as ReactComponent };